import { Body, Box, Heading, BoxProps } from '@hover/blueprint';
import React from 'react';

interface Props extends BoxProps {}

const Header: React.FC<Props> = props => (
  <Box flexDir="column" alignItems="flex-start" {...props}>
    <Body isBold size={200} color="neutral.600" mb={100}>
      CLAIMS ESTIMATION
    </Body>
    <Heading
      as="h2"
      fontWeight={{ base: 600, desktop: 600 }}
      size={{ base: 500, tablet: 600 }}
      style={{ marginBottom: 0 }}
    >
      Easy import, Fast estimation
    </Heading>
  </Box>
);

export default Header;
